/** Valores alinhados ao cadastro de parâmetros de período. */
export enum CodigoParametroPeriodo {
  PMCE = 2,
  EvidenciaPMCE = 3,
}
